import type { User } from '../../usersApi/users/user'

export class Note {
    notesId: string
    content: string
    createdAt: Date
    updatedAt: Date
    userId?: string
    personId?: string
    status: number
    user: User
}
